import React from 'react';
import { Box, Typography } from '@mui/material';
import useDataCatalog from '../../hooks/useDataCatalog';
import CatalogCard from './CatalogCard';
import { useCatalog } from '../../store/catalog.store';
import { themeColors } from '../../styles';
import CatalogCardSkeleton from './CatalogCardSkeleton';
import { useTour } from '../../provider/TourGuide';
import NewPreloader from '../Common/NewPreloader';
import CatalogEmpty from './CatalogEmpty';

const CatalogList = () => {
    const { data, isLoading } = useDataCatalog();
    const {
        search,
        selectedCategories,
        openFavorite,
        favorites,
        setSearch,
        setSelectedCategoies,
        setOpenFavorite,
    } = useCatalog();
    const {enabledCatalog} = useTour()

    return (
        <Box>
            {enabledCatalog &&
                <Box sx={{ margin: '20px 0', marginBottom:'60px' }}>
                    <CatalogCard 
                        isForTour={true}
                        item={{
                        id: 11,
                        sku: "BEAN00028",
                        title: "פולי קפה ERTA ALE",
                        description: `…`,
                        packQuantity: 10,
                        price: 120,
                        type: "product",
                        brand: { title: "MUGMA" },
                        category: {
                            type: "product",
                            isPublished: true,
                            title: "פולי קפה"
                        },
                        image: {
                            contentUrl: "",
                            source: "product",
                            filePath: "media/product/product_BEAN00028.png"
                        },
                        serialNumber: "",
                        videoLink: "",
                        pdf: "",
                        KosherType: "K1",
                        unitQuantity: "1",
                        unitname: 'ק"ג',
                        packName: 'ק"ג',
                        packName2: "בקרטון",
                        inPack: "10",
                        packUnit: "יח'",
                        minimumQuantity: 1,
                        isEditable: false,
                        itboType: "",          
                        itboConvglas: "",       
                        published: true,       
                        kosher: true,          
                        tagGroups: []          
                        }} 
                    />
                </Box>
            }
            {isLoading && 
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:'100px'}}>
                    {/* {[...Array(5)].map((_, index) => (
                        <CatalogCardSkeleton key={index} />
                    ))} */}
                    <NewPreloader/>
                </Box>
            }
            {!isLoading && !enabledCatalog && (() => {
                // Build the category blocks that actually have something to show,
                // so we can both render them and decide whether the page is empty.
                const blocks = (data ?? [])
                    .map((item) => {
                        const searchTrimmed = search?.toLowerCase().trim() || '';
                        const filteredProducts = (item.products ?? []).filter((prod) => {
                            const matchesSearch =
                                prod.sku?.toLowerCase().includes(searchTrimmed) ||
                                prod.title?.toLowerCase().includes(searchTrimmed);
                            const matchesCategory =
                                selectedCategories.length === 0 ||
                                selectedCategories.includes(item.category);
                            return matchesSearch && matchesCategory;
                        });

                        const productsToDisplay = openFavorite
                            ? favorites.filter((fav) =>
                                  filteredProducts.some((prod) => prod.id === fav.id)
                              )
                            : filteredProducts;

                        return { category: item.category, productsToDisplay };
                    })
                    // Only keep categories that have products to render — a lone
                    // category header with no items reads as broken.
                    .filter((block) => block.productsToDisplay.length > 0);

                if (blocks.length === 0) {
                    // Distinguish "nothing matched the search/filter" from a
                    // genuinely empty catalog and an empty favourites view, so the
                    // message is accurate and the page never renders blank.
                    const isFiltering =
                        !!search?.trim() || selectedCategories.length > 0;
                    const variant = openFavorite
                        ? 'favorites'
                        : isFiltering
                        ? 'search'
                        : 'empty';

                    return (
                        <CatalogEmpty
                            variant={variant}
                            onClear={() => {
                                setSearch('');
                                setSelectedCategoies([]);
                                setOpenFavorite(false);
                            }}
                        />
                    );
                }

                return blocks.map((block, key) => (
                    <Box key={key} sx={{ margin: '20px 0', marginBottom: '60px' }}>
                        <Typography
                            fontWeight={700}
                            fontSize={'15px'}
                            lineHeight={'21px'}
                            color={themeColors.title}
                            sx={{ padding: '0 10px' }}
                        >
                            {block.category}
                        </Typography>
                        {block.productsToDisplay.map((prod) => (
                            <CatalogCard key={prod.id} item={prod} />
                        ))}
                    </Box>
                ));
            })()}
        
        </Box>
    );
};

export default CatalogList;

